<script lang="ts" setup>
import Button from '~/components/Button.vue'
import { Routes } from '~/enums/Routes'
import { useStoreConfig } from '~/store/storeConfig'

const { isMobile } = useStoreConfig()

defineProps<{
  noBackground?: boolean
  noBackButton?: boolean
  col?: boolean
  noHeading?: boolean
}>()
</script>

<template>
  <div class="px-2 lg:px-0 pb-[5rem] max-w-[100vw] wl:px-4 wl:lg:px-0 wl:pb-[3rem]">
    <slot name="breadcrumbs" />
    <div class="flex gap-7">
      <LazyAccountSidebar v-if="!isMobile" />
      <div class="flex-grow w-full">
        <div v-if="!noHeading" class="flex justify-between mb-7 w-full" :class="{ 'flex-col': isMobile && col }">
          <div class="flex content-center items-center w-full">
            <template v-if="isMobile && !noBackButton">
              <div>
                <Button
                  arrow-left
                  round
                  small
                  button-type="secondary-orange"
                  class="mr-2"
                  @click="navigateTo(getLocalizedRoute(Routes.Account.AccountInformation))" />
              </div>
            </template>
            <div class="flex flex-col justify-center mr-auto">
              <h4>
                <slot name="heading" />
              </h4>
            </div>
          </div>
          <slot name="action"></slot>
        </div>
        <div class="account-content w-full" :class="{ 'no-background': noBackground }">
          <slot></slot>
        </div>
      </div>
    </div>
    <slot name="modals" />
  </div>
</template>

<style lang="postcss" scoped>
.account-content {
  @apply bg-neutral8 dark:bg-dmGray1;
  border-radius: theme('vars.borderRadiusHeavy');
}

.no-background {
  background-color: transparent !important;
}

.alt {
  .account-content {
    @apply rounded-md bg-white dark:bg-dmGray1;
  }
}
</style>
